import { render } from "./BrandSpinner.vue?vue&type=template&id=4c24161e"
import script from "./BrandSpinner.vue?vue&type=script&lang=js"
export * from "./BrandSpinner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__